import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function NewShift() {
  const nav = useNavigate();
  const [form, setForm] = useState({
    title: "Açougueiro para plantão",
    description: "",
    date: new Date(Date.now()+86400000).toISOString().slice(0,10),
    start_time: "08:00",
    end_time: "17:00",
    base_rate: 180,
    address: "",
    city: "",
    latitude: -23.5505,
    longitude: -46.6333,
  });
  const [loading, setLoading] = useState(false);
  const setField = (k, v) => setForm(s => ({ ...s, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/shifts", { ...form, base_rate: parseFloat(form.base_rate) });
      toast.success("Diária publicada!");
      nav(`/shifts/${data.shift_id}`);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-2xl anim-fade-up">
      <h1 className="text-3xl font-display font-extrabold mb-2">Publicar nova diária</h1>
      <p className="text-zinc-400 text-sm mb-6">Os profissionais próximos serão notificados imediatamente.</p>

      <form onSubmit={submit} className="cw-card p-6 space-y-4">
        <div>
          <label className="text-xs uppercase tracking-wider text-zinc-500">Título</label>
          <input required className="cw-input mt-1" value={form.title} data-testid="input-shift-title"
                 onChange={e => setField("title", e.target.value)} />
        </div>
        <div>
          <label className="text-xs uppercase tracking-wider text-zinc-500">Descrição / Requisitos</label>
          <textarea rows={3} className="cw-input mt-1" value={form.description} data-testid="input-shift-desc"
                    onChange={e => setField("description", e.target.value)}
                    placeholder="Ex: Cortes bovinos, fatiar frios, atender cliente..." />
        </div>

        <div className="grid sm:grid-cols-3 gap-3">
          <div>
            <label className="text-xs uppercase tracking-wider text-zinc-500">Data</label>
            <input required type="date" className="cw-input mt-1" value={form.date} data-testid="input-shift-date"
                   onChange={e => setField("date", e.target.value)} />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-zinc-500">Início</label>
            <input required type="time" className="cw-input mt-1" value={form.start_time} data-testid="input-shift-start"
                   onChange={e => setField("start_time", e.target.value)} />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-zinc-500">Fim</label>
            <input required type="time" className="cw-input mt-1" value={form.end_time} data-testid="input-shift-end"
                   onChange={e => setField("end_time", e.target.value)} />
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-3">
          <div>
            <label className="text-xs uppercase tracking-wider text-zinc-500">Valor base (R$)</label>
            <input required type="number" step="10" min="50" className="cw-input mt-1" value={form.base_rate} data-testid="input-shift-rate"
                   onChange={e => setField("base_rate", e.target.value)} />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-zinc-500">Cidade</label>
            <input required className="cw-input mt-1" value={form.city} data-testid="input-shift-city"
                   onChange={e => setField("city", e.target.value)} placeholder="São Paulo" />
          </div>
        </div>

        <div>
          <label className="text-xs uppercase tracking-wider text-zinc-500">Endereço</label>
          <input required className="cw-input mt-1" value={form.address} data-testid="input-shift-address"
                 onChange={e => setField("address", e.target.value)} placeholder="Rua, número, bairro" />
        </div>

        <button type="submit" disabled={loading} className="cw-btn-primary w-full flex items-center justify-center gap-2" data-testid="btn-shift-publish">
          {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Publicando…</> : "Publicar diária"}
        </button>
      </form>
    </div>
  );
}
